module.exports = __webpack_public_path__ + "img/absolut-reg-bg-mobile.6ac2fa5d.jpg";